<template>
    <a-popover
        :visible="open"
        :overlayClassName="'no-padding archive-filter'"
        placement="bottom"
        @visibleChange="(isVisible) => (open = isVisible)"
        trigger="click"
    >
        <div slot="content" style="width: auto">
            <div class="filter-wrapper-form">
                <div class="filter-wrapper-form-title">
                    <span class="material-icons closeIcon" @click="close"> close </span>
                    <span class="material-icons filterIcon" v-if="type === 'period'"> date_range </span>
                    <span class="material-icons filterIcon" v-if="type === 'visitorId'"> fingerprint </span>
                    <span class="material-icons filterIcon" v-if="type === 'conversationId'"> fingerprint </span>
                    <span class="material-icons filterIcon" v-if="type === 'integration'"> public </span>
                    <span class="material-icons filterIcon" v-if="type === 'storyId'"> schema </span>
                    <span class="material-icons filterIcon" v-if="type === 'userIds'"> badge </span>
                    <span class="filterName ml-2">{{
                        {
                            period: this.$t("headBar.date"),
                            visitorId: "User ID",
                            conversationId: "Conversation ID",
                            integration: "Integration",
                            storyId: "Story",
                        }[type]
                    }}</span>
                </div>
                <div class="w-100" v-if="type === 'period'">
                    <a-select
                        :value="cloneValue"
                        @select="handleSelect"
                        class="select-story"
                        :placeholder="$t('chatbotv2.wholeTimeSpan')"
                        :filter-option="false"
                    >
                        <a-select-option
                            v-for="period of periods"
                            :value="period.value"
                            :key="period.value"
                            @click="() => selectOptionClick(period.value)"
                        >
                            <span class="blockTypeText">{{ $t(`chatbotv2.time.${period.value}`) }}</span>
                        </a-select-option>
                    </a-select>
                </div>
                <div class="w-100 mb-3 row" v-if="type === 'visitorId'">
                    <div class="col-md-1">
                        <a-radio :checked="true" />
                    </div>
                    <div class="col-md-10 d-flex flex-column">
                        <b class="row mx-2">is</b>
                        <a-input class="row" :value="cloneValue" @blur="handleSelect($event.target.value)" />
                    </div>
                </div>
                <div class="w-100 mb-3 row" v-if="type === 'conversationId'">
                    <div class="col-md-1">
                        <a-radio :checked="true" />
                    </div>
                    <div class="col-md-10 d-flex flex-column">
                        <b class="row mx-2">is</b>
                        <a-input class="row" :value="cloneValue" @blur="handleSelect($event.target.value)" />
                    </div>
                </div>
                <div class="w-100" v-if="type === 'integration'">
                    <a-select
                        :value="cloneValue"
                        :defaultValue="$t('chatbotv2.wholeIntegration')"
                        @select="handleSelect"
                        class="select-story"
                        :placeholder="$t('chatbotv2.wholeIntegration')"
                        :filter-option="false"
                    >
                        <a-select-option
                            v-for="integration of integrations"
                            :value="integration.value"
                            :key="integration.value"
                            @click="() => selectOptionClick(integration.value)"
                        >
                            <span class="blockTypeText">{{ integration.name }}</span>
                        </a-select-option>
                    </a-select>
                </div>
                <div class="w-100" v-if="type === 'storyId'">
                    <a-select
                        :value="cloneValue"
                        @select="handleSelect"
                        class="select-story"
                        :placeholder="$t('chatbotv2.wholeStoryIds')"
                        :filter-option="false"
                    >
                        <a-select-option
                            v-for="story of stories"
                            :value="story._id"
                            :key="story._id"
                            @click="() => selectOptionClick(story._id)"
                        >
                            <span class="blockTypeText">{{ story.title }}</span>
                        </a-select-option>
                    </a-select>
                </div>
                <div class="w-100" v-if="type === 'userIds'">
                    <a-select
                        :value="cloneValue"
                        :defaultValue="$t('chatbotv2.wholeIntegration')"
                        class="select-story"
                        :placeholder="$t('chatbotv2.wholeIntegration')"
                        :filter-option="false"
                        mode="multiple"
                        v-model="cloneValue"
                    >
                        <a-select-option v-for="user of users" :value="user._id" :key="user._id">
                            <span class="blockTypeText">{{ user.name }}</span>
                        </a-select-option>
                    </a-select>
                </div>
                <div class="filter-content w-100" v-if="type === 'period' && cloneValue === 'custom' && open">
                    <VueCtkDateTimePicker
                        v-model="dateRange"
                        :range="true"
                        :min-date="new Date().toDateString()"
                        color="#faa566"
                        :label="$t('wp.scheduleFuture')"
                        :inline="true"
                    >
                    </VueCtkDateTimePicker>
                </div>
                <div style="margin-top: 20px; width: 100%" class="w-100">
                    <a-button type="primary" class="d-block w-100" :disabled="!isChanged()" @click="saveValue"
                        >{{ $t("chatbotv2.applyFilter") }}
                    </a-button>
                </div>
            </div>
        </div>

        <div class="filter-wrapper-preview">
            <span class="material-icons mainIcon" v-if="type === 'period'"> date_range </span>
            <span class="material-icons mainIcon" v-else-if="type === 'integration'"> public </span>
            <!-- story query ve ignore type ları için icon eklenmiş ama böyle type var mı? -->
            <span class="material-icons mainIcon" v-else-if="type === 'story'"> smart_toy </span>
            <span class="material-icons mainIcon" v-else-if="type === 'storyId'"> schema </span>
            <span class="material-icons mainIcon" v-else-if="type === 'query'"> format_quote </span>
            <span class="material-icons mainIcon" v-else-if="type === 'visitorId'"> fingerprint </span>
            <span class="material-icons mainIcon" v-else-if="type === 'conversationId'"> fingerprint </span>
            <span class="material-icons mainIcon" v-else-if="type === 'userIds'"> badge </span>
            <span class="material-icons mainIcon" v-else-if="type === 'ignore'"> visibility_off </span>
            <span class="material-icons mainIcon" v-else-if="type === 'userId'"> badge </span>
            <span class="material-icons closeIcon" @click="remove"> close </span>
            <span text-truncate="" text-actions="">
                <span text-weight="semi-bold"></span>
                <span>{{ label }}</span>
            </span>
        </div>
    </a-popover>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import log2 from "../../../../../utils/log2";
import { mapState, mapMutations } from "vuex";
import moment from "moment/moment";

const log = log2("MiniFilterPreview");
const defaultStartDate = moment().startOf("day").toISOString();
const defaultEndDate = moment().endOf("day").toISOString();
export default {
    name: "MiniFilterPreview",
    props: {
        value: {
            required: true,
        },
        users: {
            type: Array,
            required: false,
            default: () => [],
        },
        type: {
            type: String, //period,story,integration,visitorId
            required: true,
        },
        startDate: {
            type: String,
        },
        endDate: {
            type: String,
        },
        label: {
            type: String,
            required: true,
        },
        onRemoved: {
            type: Function,
            required: true,
        },
        onFinished: {
            type: Function,
            required: true,
        },
        defaultOpen: {
            type: Boolean,
            required: false,
            default: false,
        },
        autoRemoveWhenCancel: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        const dateRange = {};

        if (this.value === "custom") {
            dateRange.start = moment().subtract(1, "day").startOf("day");
            dateRange.end = moment().endOf("day");
        } else {
            dateRange.start = this.startDate;
            dateRange.end = this.endDate;
        }
        return {
            open: this.defaultOpen,
            cloneValue: _.cloneDeep(this.value),
            periods: [
                { value: "today" },
                { value: "yesterday" },
                { value: "last7" },
                { value: "last30" },
                { value: "this-month" },
                { value: "last-month" },
                { value: "last-3-month" },
                { value: "this-year" },
                { value: "last-year" },
                { value: "custom" },
            ],
            integrations: [
                { value: "web", name: "Supsis Widget" },
                { value: "whatsapp", name: "WhatsApp" },
            ],
            dateRange: dateRange,
        };
    },
    methods: {
        remove(e) {
            e.stopPropagation();
            e.preventDefault();
            this.cloneValue = undefined;
            this.dateRange = {};
            this.onRemoved();
        },
        saveValue() {
            log("saveValue", this.cloneValue, this.dateRange);
            this.$emit("input", this.cloneValue);
            this.$emit("dateRange", {
                startDate: this.dateRange.start,
                endDate: this.dateRange.end,
            });
            this.onFinished();
            this.open = false;
        },
        handleSelect(cloneValue) {
            this.cloneValue = cloneValue;
        },
        selectOptionClick(type) {
            if (this.cloneValue === type) {
                this.cloneValue = undefined;
            }
        },
        isChanged() {
            return (
                this.defaultOpen ||
                !_.isEqual(
                    {
                        period: this.value,
                        startDate: this.startDate,
                        endDate: this.endDate,
                    },
                    { period: this.cloneValue, startDate: this.dateRange.start, endDate: this.dateRange.end }
                )
            );
        },
        close() {
            this.open = false;
            if (this.autoRemoveWhenCancel) {
                this.onRemoved();
            }
        },
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
        }),
    },
    mounted() {
        log("clone value", this.cloneValue);
    },
    watch: {
        defaultOpen(newVal) {
            this.open = newVal;
        },
        cloneValue(newVal) {
            log("cloneValue", newVal);
        },
        open(newVal) {
            if (newVal) {
                this.$nextTick(() => {});
            }
        },
    },
};
</script>

<style lang="scss">
.filter-wrapper-form {
    align-items: flex-start;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    min-width: 325px;
    padding: 20px;
    position: relative;
    text-align: left;

    .filter-wrapper-form-title {
        align-items: center;
        cursor: default;
        display: flex;
        margin-bottom: 20px;
        width: 100%;

        .closeIcon {
            color: #008aff;
            cursor: pointer;
            font-size: 19px;
            position: absolute;
            right: 20px;
            top: 20px;
            transition: all 0.3s;
        }

        .filterIcon {
            color: #006cff;
            font-size: 16px;
            margin-right: 10px;
            position: relative;
            top: 1px;
        }

        .filterName {
            color: #22272d;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }
    }
}

.archive-filter {
    .select-story {
        width: 100%;

        //.ant-select-selection {
        //    background: #354961;
        //    border-color: #354961;
        //}

        //.anticon {
        //    color: #9ba6b3;
        //}

        //.ant-select-selection-selected-value {
        //    .blockTypeText {
        //        color: white !important;
        //    }
        //}

        &.ant-select-open {
            .blockTypeText {
                color: #000 !important;
            }
        }
    }
}
</style>
<style scoped lang="scss">
.filter-content {
    padding: 20px;
}

.filter-wrapper-preview {
    align-items: center;
    background: #2c3f84;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    display: flex;
    font-size: 16px;
    height: 32px;
    padding: 10px;
    transition: all 0.3s;
    white-space: nowrap;
    width: max-content;

    [text-truncate] {
        overflow: hidden !important;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    [text-actions] {
        cursor: pointer;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
    }

    &:hover {
        opacity: 0.8 !important;

        .material-icons {
            &.mainIcon {
                display: none;
            }

            &.closeIcon {
                display: inherit;
            }
        }
    }

    .material-icons {
        font-size: 15px;
        margin-right: 10px;

        &.mainIcon {
            display: inherit;
        }

        &.closeIcon {
            display: none;
        }
    }
}
</style>
